import {
  AppBar,
  Container,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { createTheme, styled } from "@mui/material/styles";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "./icons/CloseIcon";
import CrossedCircleIcon from "./icons/CrossedCircleIcon";
import DollarCircleIcon from "./icons/DollarCircleIcon";
import HamburgerIcon from "./icons/HamburgerIcon";
import HomeIcon from "./icons/HomeIcon";
import LogoutIcon from "./icons/LogoutIcon";
import QuestionCircleIcon from "./icons/QuestionCircleIcon";

export default function Topbar(props) {
  const theme = createTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const token = localStorage.getItem("token");

  const toggleMenu = (open) => () => {
    setMenuOpen(open);
  };

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing("24px", 3, "16px", 3),
    justifyContent: "flex-end",
  }));

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <AppBar
        position="static"
        color="transparent"
        sx={{
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
          boxShadow: "none",
        }}
        {...props}
      >
        <Container maxWidth="xl" sx={{ px: 3 }}>
          <Toolbar style={{ minHeight: 90, padding: 0, width: "100%" }}>
            <Link to={"/upload"}>
              <img src="/logo-icon.svg" alt="logo" width={131} height={30} />
            </Link>
            <IconButton
              color="inherit"
              onClick={toggleMenu(true)}
              aria-label="menu"
              sx={{ marginLeft: "auto" }}
            >
              <HamburgerIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>
      <Drawer
        anchor="right"
        open={menuOpen}
        onClose={toggleMenu(false)}
        PaperProps={{
          sx: {
            backgroundColor: "#ECEDEF",
            minWidth: "min(calc(100vw - 40px), 356px)",
          },
        }}
      >
        <DrawerHeader>
          <IconButton onClick={toggleMenu(false)} sx={{ color: "black" }}>
            <CloseIcon width={20} height={20} style={{ margin: "2px" }} />
          </IconButton>
        </DrawerHeader>

        <List
          sx={{
            padding: theme.spacing(0, 3),
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
          }}
        >
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => navigate("/upload")}
              sx={{
                p: theme.spacing(1.5),
                borderRadius: "8px",
                backgroundColor: isActive("/upload") ? "#29303C" : "inherit",
                color: isActive("/upload") && "white",
                "&:hover": {
                  backgroundColor: "#29303C",
                  color: "white",
                },
                "&:hover .MuiListItemIcon-root > svg": {
                  fill: "currentColor",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: "currentcolor",
                  minWidth: "unset",
                  marginRight: "6px",
                  "& > svg": {
                    fill: isActive("/upload") && "currentcolor",
                  },
                }}
              >
                <HomeIcon />
              </ListItemIcon>
              <ListItemText
                disableTypography
                disablePadding
                sx={{ margin: 0 }}
                primary={<Typography variant="body3">Home</Typography>}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => navigate("/how-it-works")}
              sx={{
                p: theme.spacing(1.5),
                borderRadius: "8px",
                backgroundColor: isActive("/how-it-works")
                  ? "#29303C"
                  : "inherit",
                color: isActive("/how-it-works") ? "white" : "inherit",
                "&:hover": {
                  backgroundColor: "#29303C",
                  color: "white",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: "currentcolor",
                  minWidth: "unset",
                  marginRight: "6px",
                }}
              >
                <QuestionCircleIcon />
              </ListItemIcon>
              <ListItemText
                disableTypography
                disablePadding
                sx={{ margin: 0 }}
                primary={<Typography variant="body3">How It Works</Typography>}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => navigate("/exclusions")}
              sx={{
                p: theme.spacing(1.5),
                borderRadius: "8px",
                backgroundColor: isActive("/exclusions")
                  ? "#29303C"
                  : "inherit",
                color: isActive("/exclusions") ? "white" : "inherit",
                "&:hover": {
                  backgroundColor: "#29303C",
                  color: "white",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: "currentcolor",
                  minWidth: "unset",
                  marginRight: "6px",
                }}
              >
                <CrossedCircleIcon />
              </ListItemIcon>
              <ListItemText
                disableTypography
                disablePadding
                sx={{ margin: 0 }}
                primary={<Typography variant="body3">Exclusions</Typography>}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => navigate("/pricing")}
              sx={{
                p: theme.spacing(1.5),
                borderRadius: "8px",
                backgroundColor: isActive("/pricing") ? "#29303C" : "inherit",
                color: isActive("/pricing") ? "white" : "inherit",
                "&:hover": {
                  backgroundColor: "#29303C",
                  color: "white",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: "currentcolor",
                  minWidth: "unset",
                  marginRight: "6px",
                }}
              >
                <DollarCircleIcon />
              </ListItemIcon>
              <ListItemText
                disableTypography
                disablePadding
                sx={{ margin: 0 }}
                primary={<Typography variant="body3">Pricing</Typography>}
              />
            </ListItemButton>
          </ListItem>
          {token && (
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  localStorage.removeItem("token");
                  window.location.href = "/login";
                }}
                sx={{
                  p: theme.spacing(1.5),
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#29303C",
                    color: "white",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: "currentcolor",
                    minWidth: "unset",
                    marginRight: "6px",
                  }}
                >
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  disablePadding
                  sx={{ margin: 0 }}
                  primary={<Typography variant="body3">Logout</Typography>}
                />
              </ListItemButton>
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
}
